import { render } from "./spaceDetails.vue?vue&type=template&id=4a171c70"
import script from "./spaceDetails.vue?vue&type=script&lang=js"
export * from "./spaceDetails.vue?vue&type=script&lang=js"

import "./spaceDetails.vue?vue&type=style&index=0&id=4a171c70&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__